import React from "react";

const CustomCheckBox = ({
    label,
    onChange,
    checked = false,
    disabled
}) => {
    const handleChange = (e) => {
        if (onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <div className='flex items-center space-x-2'>
            <input
                disabled={disabled}
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            {label && (
                <label className="text-[#000000]">
                    {label}
                </label>
            )}
        </div>
    );
};

export default CustomCheckBox;